import Markdown from "markdown-to-jsx";
import { FC, useCallback } from "react";
import { useNavigate } from "react-router";

import { SkuImage } from "@/components/skus/sku-image";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Header } from "@/components/ui/header";
import { SKU } from "@/data/types";
import { preserveLineBreaks } from "@/lib/markdown";

type Props = {
  sku?: SKU;
};

export const TagProductSection: FC<Props> = ({ sku }) => {
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    navigate(`/skus/${sku?.id}`);
  }, [navigate, sku?.id]);

  return (
    <div className="flex flex-col w-full">
      <Header title="Product Info" />
      <Card className="h-full mt-4">
        <CardContent className="my-6 px-6 mx-0 pb-0">
          <SkuImage
            src={sku?.image_url}
            alt={sku?.name}
            className="max-w-md max-h-md min-w-md min-h-md mb-4 aspect-square"
            srcSetWidths={[1200, 2000, 3000, 4000]}
            hasSquareCrop
          />
          <Markdown>
            {sku?.description ? preserveLineBreaks(sku?.description) : ""}
          </Markdown>
        </CardContent>
        <CardFooter className="border-t px-6 py-4">
          <Button onClick={handleClick}>Go to SKU</Button>
        </CardFooter>
      </Card>
    </div>
  );
};
